/**
 * Returns the base URL for internal API calls (Next.js API routes).
 * Server-side always uses localhost to avoid DNS/external network hops.
 * Client-side uses the browser origin automatically (relative URLs),
 * but this helper is mainly consumed by server-side fetches.
 */
export function getBaseUrl(): string {
  if (typeof window !== "undefined") {
    return window.location.origin;
  }

  if (process.env.VERCEL_URL) {
    return `https://${process.env.VERCEL_URL}`;
  }

  return `http://localhost:${process.env.PORT || 3000}`;
} 